/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { SimpleAction } from './simple-action';

export class SwitchAction<T> extends SimpleAction<T> {
  public isActive: boolean;
  public constructor(
    name: string,
    icon: string,
    placeholder: string,
    isActive?: boolean,
    align?: 'left' | 'center' | 'right'
  ) {
    super(name, icon, null, placeholder);
    this.isActive = isActive;
    this.category = 'switch';
    if (align) {
      this.align = align;
    }
  }

  /**
   * @deprecated
   * Use category property
   */
  override getActionType(): string {
    return 'switch';
  }
}
